module.exports = __webpack_public_path__ + "static/media/menu2.f7a0a1af.jpg";